import { render, staticRenderFns } from "./ProductStyles.vue?vue&type=template&id=0a4618c2&scoped=true&"
import script from "./ProductStyles.vue?vue&type=script&lang=js&"
export * from "./ProductStyles.vue?vue&type=script&lang=js&"
import style0 from "./ProductStyles.vue?vue&type=style&index=0&id=0a4618c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4618c2",
  null
  
)

export default component.exports